var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJengoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 242,
    viewBox: "0 0 184 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 111.5,
    width: 50,
    height: 64,
    rx: 25,
    fill: "#7572F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 45.5,
    width: 50,
    height: 130,
    rx: 25,
    fill: "#7572F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 0.5,
    width: 50,
    height: 175,
    rx: 25,
    fill: "#7572F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 149.5C-2.13311e-06 173.9 9.69282 197.3 26.9462 214.554C44.1995 231.807 67.6001 241.5 92 241.5C116.4 241.5 139.8 231.807 157.054 214.554C174.307 197.3 184 173.9 184 149.5L134.32 149.5C134.32 160.724 129.861 171.488 121.925 179.425C113.988 187.361 103.224 191.82 92 191.82C80.776 191.82 70.0118 187.361 62.0752 179.425C54.1387 171.488 49.68 160.724 49.68 149.5L0 149.5Z",
    fill: "#7572F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJengoLogo);
export default __webpack_public_path__ + "static/media/jengo_logo.f06797cf0c93a6c53e75a49e32a0d6bf.svg";
export { ForwardRef as ReactComponent };